import api from "../service/emitir.service";
import * as types from "./emitir.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import apiFileManager from "@/modules/common/app/helpers/fileManager-service";
//Actions
import empresaActions from "./emitir.actions";

//selectors
import empresaSelector from "./emitir.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.SAVE, save);
}

function* save(action) {
  const { payload } = action;

  const state = yield select(empresaSelector.emitir);

  const dto = {
    InscricaoMunicipal: payload.InscricaoMunicipal,
    CpfCnpj: payload.CpfCnpj,
    Exercicio: parseInt(payload.Exercicio)
  };

  if (state.tokenRecaptcha){
    var result = yield call(api.save, dto, {
      headers: { tokenRecaptcha: state.tokenRecaptcha }
    });

    if(result.data) yield call(apiFileManager.directDownload,result.data.Url);
  }

  else yield _alert.warning("É necessário validar o ReCaptcha.");
}
